










import { Vue, Component } from 'vue-property-decorator';
import AtencionesBase from './AtencionesBase.vue';

@Component({
  components: { AtencionesBase },
})
export default class AtencionesPantalla extends Vue {}
